import React from "react";
import { XCircle } from "react-feather";
import useLanguage from "../../hooks/language";
import { Button } from "../../components";
import IndexPointingUpEmoji from "../../assets/images/index-pointing-up.png";

import "./hpv-treatment-disclaimer.css";

export default function HPVTreatmentDisclaimer({
    onClose,
}: {
    onClose?: () => void;
}): React.ReactElement {
    const { translations } = useLanguage();
    const t = translations.hpvTreatmentDisclaimer;

    return (
        <>
            <div className="hpv-treatment-disclaimer-modal__close">
                <button
                    className="hpv-treatment-disclaimer-modal__close-button"
                    aria-label={translations.common.close}
                    onClick={onClose}
                >
                    <XCircle aria-hidden="true" focusable="false" />
                </button>
            </div>

            <div className="hpv-treatment-disclaimer-modal__content">
                <div className="hpv-treatment-disclaimer-modal__title-container">
                    <h3 className="hpv-treatment-disclaimer-modal__title">
                        {t.title}
                    </h3>
                </div>

                <div>
                    <ul>
                        {t.items.map((item) => (
                            <li key={item.emphasis}>
                                <strong>{item.emphasis}</strong>
                                {item.text}
                            </li>
                        ))}
                    </ul>
                    <p className="hpv-treatment-disclaimer-modal__positive-result">
                        <img
                            src={IndexPointingUpEmoji}
                            alt=""
                            aria-hidden="true"
                            className="hpv-treatment-disclaimer-modal__positive-result-icon"
                        />
                        <span>
                            <strong>{t.positiveResult.emphasis}</strong>
                            {t.positiveResult.text}
                        </span>
                    </p>
                    <div className="dual-button-holder hpv-treatment-disclaimer-modal__actions">
                        <Button onClick={onClose}>
                            {t.understoodButtonText}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
}
